import { Button, SmartLink, XStack } from '@my/ui'
import { ButtonBlock } from './button.block'

const alignmentMap = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
} as const

export const ButtonComponent = (block: ButtonBlock) => {
  return (
    <XStack ai="center" jc={alignmentMap[block.buttonAlignment || 'center']}>
      <SmartLink
        Component={Button}
        theme="primary"
        br="$3"
        href={block.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        {block.label}
      </SmartLink>
    </XStack>
  )
}
